import { PropsWithChildren, useCallback } from 'react';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction } from '~/shared';
import { StyledGrid } from './ShopGridProducts.styled';

interface IShopGridProducts {
	handleSetActive: (index: number) => void;
	handleSelect: (index: number) => void;
	activeIndex: number | null;
	maxIndex: number;
}

const ShopGridProducts = ({
	children,
	handleSetActive,
	handleSelect,
	activeIndex,
	maxIndex,
	...props
}: IShopGridProducts &
	PropsWithChildren &
	React.HTMLAttributes<HTMLDivElement>) => {
	const modalState = useObservable(rage.modal.getCurrentModal());

	const handleMenuNavigation = useCallback(
		(offset: number) => {
			if (modalState) {
				return;
			}

			if (activeIndex === null) {
				handleSetActive(0);
				return;
			}

			const newIndex = activeIndex + offset;

			if (newIndex >= 0 && newIndex < maxIndex) {
				handleSetActive(newIndex);
			}
		},
		[activeIndex, maxIndex, handleSetActive, modalState],
	);

	useInputAction(InputAction.CommonMenuAccept, () => {
		if (modalState) {
			return;
		}

		if (activeIndex === null) {
			handleSetActive(0);
			return;
		}

		if (handleSelect) {
			handleSelect(activeIndex);
		}
	});

	useInputAction(InputAction.CommonMenuNavUp, () => handleMenuNavigation(-2));
	useInputAction(InputAction.CommonMenuNavDown, () => handleMenuNavigation(2));
	useInputAction(InputAction.CommonMenuNavLeft, () => handleMenuNavigation(-1));
	useInputAction(InputAction.CommonMenuNavRight, () => handleMenuNavigation(1));

	return (
		<StyledGrid tabIndex={-1} {...props}>
			{children}
		</StyledGrid>
	);
};

export { ShopGridProducts };
